import * as React from 'react';
import Modal from 'antd/lib/modal';
import Space from 'antd/lib/space';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { antGrey } from './styles/globalStyles';
import TooltipInfoIcon from './helperComponents/TooltipInfoIcon';

interface SkipReleaseModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: (shouldRollForwardMetadata: boolean, shouldDevRejectRelease: boolean) => void;
    isAndroid?: boolean;
    isAppleAppStore?: boolean;
}

export const SkipReleaseModal: React.FC<SkipReleaseModalProps> = ({
    open,
    onCancel,
    onConfirm,
    isAndroid = false,
    isAppleAppStore = false,
}) => {
    const [shouldRollForwardMetadata, setShouldRollForwardMetadata] = React.useState(true);
    const [shouldDevRejectRelease, setShouldDevRejectRelease] = React.useState(false);

    const handleRollForwardChange = (event: CheckboxChangeEvent) => {
        setShouldRollForwardMetadata(event.target.checked);
    };

    const handleDevRejectChange = (event: CheckboxChangeEvent) => {
        setShouldDevRejectRelease(event.target.checked);
    };

    const handleConfirm = () => {
        onConfirm(shouldRollForwardMetadata, shouldDevRejectRelease);
    };

    return (
        <Modal
            title="Are you sure you want to skip this release?"
            open={open}
            onCancel={onCancel}
            footer={(_, { CancelBtn }) => (
                <Space>
                    <CancelBtn />
                    <Button type="primary" onClick={handleConfirm}>
                        Yes, skip release
                    </Button>
                </Space>
            )}
            centered
            width={500}
            destroyOnClose
        >
            <Flex vertical gap={16} style={{ width: '100%' }}>
                <Text style={{ fontSize: 14, color: antGrey.grey8 }}>
                    The release record will stay in Runway but appear as skipped in the release timeline.
                </Text>

                <Flex align="center" gap={2}>
                    <Checkbox checked={shouldRollForwardMetadata} onChange={handleRollForwardChange}>
                        Roll forward metadata changes from this release
                    </Checkbox>
                    <TooltipInfoIcon
                        tooltipContent={`This will ensure that any metadata changes (${isAndroid ? 'Release notes' : "What's new"}, etc.) made to this release are applied to the next active release.`}
                    />
                </Flex>

                {isAppleAppStore && (
                    <Flex align="center" gap={2}>
                        <Checkbox checked={shouldDevRejectRelease} onChange={handleDevRejectChange}>
                            Pull active app submission
                        </Checkbox>
                        <TooltipInfoIcon tooltipContent="If there is an active app submission for this version, it will be pulled from the App Store." />
                    </Flex>
                )}
            </Flex>
        </Modal>
    );
};
